import Component from "./createTeam";

import {bindActionCreators} from "redux";
import {createNewTeam} from '../../store/actions/teams';
import {getComingEvents} from '../../store/actions/events';
import {getBusyCarNumber} from '../../store/actions/carNumber';
import {getCarValues} from '../../store/actions/carValues';
import {getRacingBracket} from '../../store/actions/racingBraket';
import connect from "react-redux/es/connect/connect";



function mapStateToProps(state) {
    const teams = state.teams;
    const events = state.events;
    const number = state.number;
    const carValues = state.carValues;
    const racingBracket = state.racingBracket;

    return {
        teams,
        events,
        number,
        carValues,
        racingBracket
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({createNewTeam, getComingEvents, getBusyCarNumber, getCarValues, getRacingBracket}, dispatch);
}

export const CreateTeam = connect(mapStateToProps, mapDispatchToProps)(Component);